module.exports = __webpack_public_path__ + "static/media/dark.2c8a7283.png";